import React, { useState, useMemo, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { darken, lighten } from "polished";
import Sidebar from "../../components/sideBar/sideBar.js";
import Navbar from "../../components/navbar/navbar.js";
import gridSideBar from "../../components/GridSideBar/gridSideBar.js";
import createColumnDefs from "./columnDefs.js";
import localStorage from "local-storage";
import SearchIcon from "@mui/icons-material/Search";

import { Grid, Typography, TextField, MenuItem, Button } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import localeTextTr from "../../locale.tr.js";
import Swal from "sweetalert2";
import moment from "moment";
import { cleanupLocalStorage } from "../../utils/localStorage/cleanupLocalStorage.js";
import { createTurkishFilterParams } from "../../utils/agGridTextFilterTr/agGridFilterUtils.js";
import DateRangePicker from "../../components/DateRangePicker/index.js";
import { getTaxpayerListForCustomerCards } from "../../api/customerCards/getTaxPayerListForCustomerCards.js";
import TaxpayerCardAndTransactions from "./details.js";
import AddFinancialTransactionModal from "./addTransaction.js";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

function CustomerCards() {
  const [rowData, setRowData] = useState([]);
  const [taxpayerListForTransaction, setTaxpayerListForTransaction] = useState(
    []
  );
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const [isOpen, setIsOpen] = useState(false);
  const [startDate, setStartDate] = useState(moment().startOf("year")); // 1 Ocak
  const [endDate, setEndDate] = useState(moment()); // Bugünün tarihi
  const [gridApi, setGridApi] = useState(null);

  useEffect(() => {
    const sideBarOpen = localStorage.get("sidebar");

    if (sideBarOpen === "false") {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
    localStorage.get("scrollPosition");

    search();
    cleanupLocalStorage();
    window.addEventListener("beforeunload", cleanupLocalStorage);
    return () => {
      window.removeEventListener("beforeunload", cleanupLocalStorage);
    };
  }, []);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };
  const [selectedTaxpayerId, setSelectedTaxpayerId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [searchForTransaction, setSearchForTransaction] = useState(false);
  const [modalOpenForTransaciton, setModalOpenForTransaciton] = useState(false);

  const openModal = (id) => {
    setSelectedTaxpayerId(id);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedTaxpayerId(null);
  };

  const defaultColDef = useMemo(
    () => ({
      minWidth: 100,
      filter: true,
      sortable: true,
      resizable: true,
      floatingFilter: true,
      filterParams: createTurkishFilterParams(),
    }),
    []
  );

  const search = () => {
    setLoading(true);

    getTaxpayerListForCustomerCards(startDate, endDate)
      .then((resp) => {
        // Sadece id ve title olan array'i oluştur
        if (resp?.data?.data) {
          const simplifiedList = resp?.data?.data?.map(({ id, title }) => ({
            id,
            title,
          }));
          setTaxpayerListForTransaction(simplifiedList);
        }

        setRowData(resp.data.data || []);
        setTotalCount(resp.data.count);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        Swal.fire({
          text:
            err?.response?.data?.message ||
            "Mükellefler alınırken hata oluştu.",
          icon: "error",
          confirmButtonText: "Tamam",
          customClass: {
            container: ".swal-overlay",
          },
        });
      });
  };

  const [columnDefs, setColumnDefs] = useState(createColumnDefs(openModal));

  const detailCellRendererParams = useMemo(() => {
    return {
      detailGridOptions: {
        columnDefs: [
          { field: "type", headerName: "Tür", flex: 1, maxWidth: 150 },
          { field: "description", headerName: "Açıklama", flex: 3 },
          {
            field: "amount",
            headerName: "Tutar",
            flex: 1,
            valueFormatter: (params) =>
              params.value.toLocaleString("tr-TR") + " ₺",
          },
        ],
        defaultColDef: {
          resizable: true,
          sortable: true,
          filter: true,
        },
        defaultExpanded: false,
      },
      getDetailRowData: (params) => {
        const details = params.data.details;
        console.log(params.data.details, "Detail data");
        // TAHAKKUK ve TAHSILAT altındaki objeleri düzleştir
        const rowData = [];

        if (details.TAHAKKUK) {
          for (const [key, value] of Object.entries(details.TAHAKKUK)) {
            rowData.push({
              type: "TAHAKKUK",
              description: key,
              amount: value,
            });
          }
        }

        if (details.TAHSILAT) {
          for (const [key, value] of Object.entries(details.TAHSILAT)) {
            rowData.push({
              type: "TAHSILAT",
              description: key,
              amount: value,
            });
          }
        }

        params.successCallback(rowData);
      },
    };
  }, []);

  const onGridReady = useCallback(
    (params) => {
      setGridApi(params.api); // gridApi'yi burada ayarlayın
      setRowData(rowData); // mevcut satır verilerini ayarlayın
    },
    [rowData]
  );

  return (
    <Grid container>
      <Grid
        item
        sx={{
          flexBasis: isOpen ? "275px" : "95px",
          flexShrink: 0,
          transition: "flex-basis 0.3s ease", // Düzeltilmiş transition
        }}
      >
        <Sidebar status={isOpen} toggleSidebar={toggleSidebar} />
      </Grid>

      <Grid
        item
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "flex-end",
          flexDirection: "column",
          gap: 1,
          pr: "12px",
        }}
      >
        <Grid item xs={12}>
          <Navbar />
        </Grid>
        <Grid item md={12} sx={{ display: "flex", flexDirection: "column" }}>
          <Grid
            className="ag-theme-quartz"
            style={{
              flex: 1,
              minHeight: "80vh",
              maxHeight: "80vh",
              width: "100%",
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              borderRadius: "10px", // İstediğiniz değeri buraya ekleyin
              overflow: "hidden", // Border-radius'in düzgün görünmesi için
            }}
          >
            <AgGridReact
              localeText={localeTextTr}
              rowSelection="multiple"
              rowData={rowData}
              columnDefs={columnDefs}
              onGridReady={onGridReady}
              loading={loading}
              sideBar={gridSideBar}
              getRowStyle={(params) => {
                if (params.data.is_deleted === true) {
                  return { background: lighten(0.4, "red") };
                }
              }}
              context={{ openModal }}
              copyHeadersToClipboard={false}
              defaultColDef={defaultColDef}
              masterDetail={true}
              detailCellRendererParams={detailCellRendererParams}
              suppressRowDeselection={true}
              enableRangeSelection={true}
              rowMultiSelectWithClick={true}
            />
            {modalOpen && (
              <TaxpayerCardAndTransactions
                open={modalOpen}
                onClose={closeModal}
                taxpayerId={selectedTaxpayerId}
                setModalOpenForTransaciton={setModalOpenForTransaciton}
                searchForTransaction={searchForTransaction}
                setSearchForTransaction={setSearchForTransaction}
                taxpayerList={taxpayerListForTransaction}
              />
            )}
            {modalOpenForTransaciton && (
              <AddFinancialTransactionModal
                open={modalOpenForTransaciton}
                onClose={() => setModalOpenForTransaciton(false)}
                taxpayerList={taxpayerListForTransaction}
                initialTaxpayerId={selectedTaxpayerId}
                setSearchForTransaction={setSearchForTransaction}
              />
            )}
          </Grid>

          <Grid
            item
            xs={12}
            sx={{
              justifyContent: "space-between",
              display: rowData?.length === 0 ? "none" : "flex",

              alignItems: "center",
            }}
          >
            <Grid
              item
              xs={12}
              sx={{
                justifyContent: "center",
                display: rowData?.length === 0 ? "none" : "flex",
                margin: "2% 0 2% 0",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  position: "absolute",
                  right: "3%",
                  display: !loading ? "block" : "none",
                }}
              >
                Toplam Kayıt : {totalCount}{" "}
              </Typography>
            </Grid>
            {/* addtax */}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default CustomerCards;
